import React from 'react';
import './BackButton.css'; // Style this button component as needed
import { config } from '../config/config';

const BackButton = ({ onClick, title = 'Back' }) => (
  <button className="back-button" onClick={onClick}>
    <img src={config.Backbutton} alt="Back" />
    <span>{title}</span>
  </button>
);

export default BackButton;
